var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('iframe', { staticClass: "model-conversion", style: _vm.builtInStyle, attrs: { "id": _vm.id, "src": _vm.iframeURL, "frameborder": "0" } });
};
var staticRenderFns = [];

export { render, staticRenderFns };